import { HttpClient} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable  } from 'rxjs';
import { map } from 'rxjs/operators'
import { EnvService } from '../../core/env.service';
import {QueryBuilderFilterRule} from '../model/QueryBuilderFilterRule';

@Injectable()

export class RuleService {
    constructor(private _httpClient: HttpClient,public _env: EnvService) {
    }

    GetRules(page:Number,pageSize:Number): Observable<Array<QueryBuilderFilterRule>> {
        return this._httpClient.get<Array<QueryBuilderFilterRule>>(this._env.apiRule +'Rule/GetRules?page=1&&pageSize=10')
        .pipe(map((res: Array<QueryBuilderFilterRule>) => res));
    }
    
    AddRules(data:QueryBuilderFilterRule): Observable<QueryBuilderFilterRule> {
        return this._httpClient.post<QueryBuilderFilterRule>(this._env.apiRule +'Rule/AddRules',data)
        .pipe(map((res: QueryBuilderFilterRule) => res));
    }

    UpdateRules(data:QueryBuilderFilterRule): Observable<QueryBuilderFilterRule> {
        return this._httpClient.post<QueryBuilderFilterRule>(this._env.apiRule +'Rule/UpdateRules',data)
        .pipe(map((res: QueryBuilderFilterRule) => res));
    }
    
    GetRulesWithChild(id: Number) {
        return this._httpClient.get<any>(this._env.apiRule +'Rule/GetRulesById?id='+id)
        .pipe(map((res: any) => res));
    }

    DeleteRulesWithChild(id:Number): Observable<QueryBuilderFilterRule> {
        return this._httpClient.get<QueryBuilderFilterRule>(this._env.apiRule +'Rule/DeleteRules?id='+id)
        .pipe(map((res: QueryBuilderFilterRule) => res));
    }
    TestRules(data:QueryBuilderFilterRule): Observable<QueryBuilderFilterRule> {
        return this._httpClient.post<QueryBuilderFilterRule>(this._env.apiRule +'Rule/TestInvoicesRules',data)
        .pipe(map((res: QueryBuilderFilterRule) => res));
    }
}